<template>
  <div class="assesment-overview" v-show="isActive">
    <div class="html-content" v-html="satContent.OverviewBody"></div>

    <div>
      <div class="count">
        {{ assessmentCount }} assessment{{ assessmentCount === 1 ? "" : "s" }}
      </div>
      <hr class="solid" />
      <div v-for="(sat, i) in satContent.Tools" :key="sat.Id">
        <hr v-if="i>0" class="solid-2" />
        <div class="assesment-name">{{ sat.Name }}</div>
        <div
          class="html-content"
          v-html="sat.OverviewPageIntroduction"
        ></div>
        <div tabindex="0" role="button" class="show-link mb-3" @keydown.enter="toggleSatDetails(i)" @click="toggleSatDetails(i)" >
          <span v-show="activeSatDetail === i"
            >Hide details <span class="angle-up-green"></span
          ></span>  
          <span  v-show="activeSatDetail !== i"
            >Show details <span class="angle-down-green"></span
          ></span>
        </div>
        <div
          class="html-content"
          ref="satDetails"
          v-html="sat.OverviewPageDetails"
          v-show="activeSatDetail === i"
        ></div>
        <div>
          <!-- TODO: link button to assessment page -->
          <button  role="button" @click="routeToSat(sat.Id)" @keydown="routeToSat(sat.Id)" class="cta-white-219">Start assessment<span class="angle-right-white"></span></button>
        </div>
         
      </div>
    </div>
    <div class="space"></div>
  </div>
</template>

<script>
import { privateRouter } from "../router";

export default {
  name: "OverviewHome",
  data() {
    return {
      assessmentCount: this.satContent.Tools.length,
      isActive: true,
      activeSatDetail: -1
    };
  },
  created() {},
  props: {
    satContent: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    toggleSatDetails(i) {
      if (this.activeSatDetail === i) {
        this.activeSatDetail = -1; //hide detail if already active
      } else {
        this.activeSatDetail = i;
      }
    },
    routeToSat(satId) {
      privateRouter.push({
        name: "AssessmentStart",
        query: {
          satId: satId
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped></style>
